import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import rem from 'polished/lib/helpers/rem'
import Pane from 'components/Common/Pane'
import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import HighIntentOffersCarousel from 'components/OfferList/HighIntent/HighIntentOffersCarousel'
import { getHighIntentHotelOffers } from 'selectors/recomendations/highIntentSelectors'
import HeadingTextBlock from 'components/Luxkit/TextBlocks/HeadingTextBlock'
import config from 'constants/config'
import { useTranslation } from 'react-i18next'

const Section = styled(Pane)`
  padding: ${rem(24)} 0;
`

interface Props {
  highIntentOffers: Array<App.HighIntentOffer>;
}

function HotelsPageHighIntentHotels(props: Props) {
  const { highIntentOffers } = props
  const { t } = useTranslation('offerList')

  if (highIntentOffers.length === 0 || !config.LERE_HIGH_INTENT_CAROUSEL_ENABLED) {
    return null
  }

  return <Section>
    <LayoutContainer>
      <VerticalSpacer gap={12}>
        <HeadingTextBlock variant="heading5">{t('Still interested in these hotels?', { ns: 'offerList' })}</HeadingTextBlock>
        <HighIntentOffersCarousel
          highIntentOffers={highIntentOffers}
          analyticsLabel="hotels"
        />
      </VerticalSpacer>
    </LayoutContainer>
  </Section>
}

function mapStateToProps(state: App.State) {
  return {
    highIntentOffers: getHighIntentHotelOffers(state),
  }
}

export default connect(mapStateToProps)(HotelsPageHighIntentHotels)
